export const USER_TOKEN_KEY = 'x-tut'
